export class ReportUtil {

  constructor() {}

  public hasUserProof(user, proof) {
    return user.user.pessoa.prestador.formacoes[0].descricao === proof;
  }

  public formatMounth(mounth) {
    let mounthStr;
    switch(mounth) {
      case 1: {
        mounthStr = 'Janeiro';
        break;
      }
      case 2: {
        mounthStr = 'Fevereiro';
        break;
      }
      case 3: {
        mounthStr = 'Março';
        break;
      }
      case 4: {
        mounthStr = 'Abril';
        break;
      }
      case 5: {
        mounthStr = 'Maio';
        break;
      }
      case 6: {
        mounthStr = 'Junho';
        break;
      }
      case 7: {
        mounthStr = 'Julho';
        break;
      }
      case 8: {
        mounthStr = 'Agosto';
        break;
      }
      case 9: {
        mounthStr = 'Setembro';
        break;
      }
      case 10: {
        mounthStr = 'Outubro';
        break;
      }
      case 11: {
        mounthStr = 'Novembro';
        break;
      }
      case 12: {
        mounthStr = 'Dezembro';
        break;
      }
    }
    return mounthStr;
  }
}
